<template>
  <ExternalQueryList
      headline="Article Flags"
      endpoint="/api/v2/content-article-flags"
      :endpoint-filters="{portal_id: portal.id}"
      :headlines="headlines"
      :filters="filters"
      :can-destroy="() => true"
      :can-update="() => true"
      :checkbox-column-width="2"
      :button-column-width="2"
      @show="contentArticleFlag => $router.push(getUrl(contentArticleFlag))"
  >
    <template v-slot:default="{ row: contentArticleFlag }">
      <td>
        <router-link :to="getUrl(contentArticleFlag)">
          {{ contentArticleFlag.attributes.name }}
        </router-link>
      </td>

      <td>
        {{ contentArticleFlag.attributes.color }}
      </td>
    </template>

    <template v-slot:headline-right>
      <router-link
          class="btn btn-white btn-sm"
          style="margin-top: 4px;"
          :to="'/portals/' + portal.id + '/content/article-flags/create'"
      >
        <i class="fa fa-plus"></i> Create
      </router-link>
    </template>
  </ExternalQueryList>
</template>

<script>
import ExternalQueryList from '../../../Panels/Lists/ExternalQuery'

export default {
  components: {ExternalQueryList},

  props: {
    portal: {
      required: true
    }
  },

  computed: {
    headlines() {
      return [
        {width: 10, text: 'Name'},
        {width: 10, text: 'Color'},
      ]
    },

    filters() {
      return [
        [
          {
            width: 20,
            widget: 'text',
            name: 'search',
            placeholder: 'Search...'
          },
          {
            width: 4,
            widget: 'submit'
          }
        ]
      ]
    }
  },

  methods: {
    getUrl(contentArticleFlag) {
      return '/portals/' + this.portal.id + '/content/article-flags/' + contentArticleFlag.id + '/edit'
    }
  }
}
</script>
